function initImageCarousel() {
  const carousels = document.querySelectorAll(".splide_image_carousel");

  if (!carousels.length) {
    return;
  }

  carousels.forEach((carousel) => {
    const splide = new Splide(carousel, {
      type: "loop",
      drag: "free",
      focus: "center",
      // perPage: 4,
      autoScroll: {
        autoStart: true,
        speed: 2,
      },
    });

    splide.mount(window.splide.Extensions);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initImageCarousel();

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      initImageCarousel();
    });
  }
});
